enum ClassifierValueType {
  DEFAULT = 'user-entered value',
  PLANT_PROTECTION_PRODUCTS = 'system value - plant protection products',
  FERTILIZERS = 'system value - fertilizers',
  BIOCIDES = 'system value - biocides',
  OTHER = 'system value - other',
}

export default ClassifierValueType;
